import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueAgile from 'vue-agile'
import Vuelidate from 'vuelidate'
import Notifications from 'vue-notification'
import Axios from 'axios'
import VueMoment from 'vue-moment'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueAgile)
Vue.use(Vuelidate)
Vue.use(Notifications)
Vue.use(VueMoment)

const axios = Axios.create()
Vue.prototype.$http = axios

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
